import {
  OrderSummary,
  CustomerOrderDetails,
  OrderFormat,
  OrderStatus,
  PreOrderStatus,
  CustomerCheckoutListItemAttendee,
  CustomerCheckoutListItem,
  Amount,
  TicketStatus,
  TicketItemStatus,
  ServiceTime,
  CheckoutStatus,
  OrderType,
  CustomerOrderListItem,
  CustomerOrderListItemOrderItem,
  CustomerCheckoutListItemPreOrderInfo,
} from '@ancon/wildcat-types'
import { EntityState } from '@reduxjs/toolkit'

export type OrderReducerState = {
  activeOrders: EntityState<CustomerCheckoutListItem>
  activeOrderFetchPending: boolean

  pastOrders: EntityState<CustomerOrderListItem>
  pastOrdersFetchPending: boolean

  upcomingOrders: EntityState<CustomerCheckoutListItem>
  upcomingOrdersFetchPending: boolean

  orderDetailsFetchPending: boolean
  orderDetails: CustomerOrderDetails | null

  orderReceiptSendPending: boolean
  isReceiptDownloadPending: boolean

  checkOrderSummary: OrderSummary | null
  checkOrderSummaryTickets: EntityState<CheckOrderTicketEntity>
  checkOrderSummaryFetchPending: boolean
}

export type QROrderStatusPageQuery = {
  orderId: string
}

export interface OrderSummaryProps {
  id: string
  outlet: {
    id: string
    name: string
    logoId: string | null
  }
  status: OrderStatus | CheckoutStatus
  orderFormat: OrderFormat
  createdAt: string
  serviceTime?: ServiceTime | null
  totalAmount: Amount
  items?: CustomerOrderListItemOrderItem[]
  attendees?: CustomerCheckoutListItemAttendee[]
  ticketNumber: number
  orderType?: OrderType
  hostAttendeeId?: string | null
  preOrderStatus?: PreOrderStatus
  preOrderInfo?: CustomerCheckoutListItemPreOrderInfo | null
  totalAmountPlusTip: Amount
}

export enum OrdersTab {
  Active = 'ongoing',
  Past = 'past',
  Upcoming = 'upcoming',
}

export type MyOrdersPageQuery = {
  tab?: OrdersTab
}

export type CheckOrderTicketEntityTicketItem = {
  id: string
  status: TicketItemStatus
  orderItemId: string
  /** Ticket items of sub-products, if order item is a multi-product */
  ticketItems: Array<{
    id: string
    status: TicketItemStatus
  }>
  hasModifications: boolean
}

export type CheckOrderTicketEntity = {
  id: string
  status: TicketStatus
  ticketItems: Array<CheckOrderTicketEntityTicketItem>
}
